import { render, staticRenderFns } from "./ChargebackAnalyticsEthocaTable.vue?vue&type=template&id=69138324&"
import script from "./ChargebackAnalyticsEthocaTable.vue?vue&type=script&lang=js&"
export * from "./ChargebackAnalyticsEthocaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
